import type { QueryClient } from "@tanstack/react-query";
import { api } from "@/api";

/**
 * After who's asking changes (sign-in or out, a share link opened or left, a preview started or
 * ended): drop every cached response, which belonged to the old identity, then reload /api/me so
 * the app re-renders as the new one. (queryClient.clear() alone doesn't tell mounted queries.)
 */
export async function switchIdentity(queryClient: QueryClient) {
  queryClient.removeQueries({ predicate: (q) => q.queryKey[0] !== "me" });
  await queryClient.fetchQuery({ queryKey: ["me"], queryFn: api.me, staleTime: 0 });
}
